// extracted by mini-css-extract-plugin
module.exports = {"container":"_hcp-moa_container__UPbAB","hcpmoapgheading":"_hcp-moa_hcpmoapgheading__YFKnZ"};